// 路由配置
import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/vuex';
import { useGtm } from '@gtm-support/vue-gtm';
import { loadLanguageAsync } from '@/assets/i18n';

//--------------------- Header ---------------------//
import RouterViewPage from './pages/RouterView.vue'; // RouterView
import Index from './pages/IndexPage.vue'; // 首頁

//*** Products & ShoppingCart ***//
import Products from './pages/products/Products.vue'; // 新購票中心
import ProductInfo from './pages/products/ProductsInfo.vue'; // 新商品頁
import ShoppingCart from './pages/ShoppingCart.vue'; // 新商品頁
import OrderComplete from './pages/OrderComplete.vue'; // 訂單完成頁面
import OrderCompleteStreaming from './pages/OrderCompleteStreaming.vue'; // 訂單完成頁面

//*** Shop ***//
import giftShop from './pages/GiftShop/GiftShop.vue'; // 禮物商店
import giftPack from './pages/GiftShop/GiftPack.vue'; // 禮包折扣
import giftItem from './pages/GiftShop/GiftItem.vue'; // 商品

//*** FAQ ***//
import FAQ from './pages/FAQ.vue'; // 常見問題
import AccountIssues from './pages/faq/AccountIssues.vue'; //帳號問題
import TicketIssues from './pages/faq/TicketIssues.vue'; //票務問題
import RedemptionGuide from './pages/faq/RedemptionGuide.vue'; //兑票教學
import BeatdayUsage from './pages/faq/BeatdayUsage.vue'; //BEATDAY使用
import Maintenance from './pages/MaintenancePage.vue'; // Error
//*** About Us ***//
import AboutUs from './pages/AboutUs.vue'; //關於我們 RouterView
import AboutBeatday from './pages/aboutUs/AboutBeatday.vue'; // 關於 BEATDAY
import HistoryReview from './pages/aboutUs/HistoryReview.vue'; // 精選回顧
import HistoryReviewDetail from './pages/aboutUs/HistoryReviewDetail.vue'; // 精選回顧子頁
import BusinessCooperation from './pages/aboutUs/BusinessCooperation.vue'; //商務合作
import ContactUs from './pages/aboutUs/ContactUs.vue'; //聯繫我們

//--------------------- Footer ---------------------//
//*** Legal ***//
import Legal from './pages/Legal.vue';
import Privacy from './pages/legal/Privacy.vue';
import UserPolicy from './pages/legal/UserPolicy.vue';
import SalesAndReturnPolicy from './pages/legal/SalesAndReturnPolicy.vue';
import LegalVersions from './pages/legal/LegalVersions.vue';
import ReturnPolicyMizukiLin from './pages/legal/ReturnPolicy_MizukiLin.vue'; //林襄退換貨規則
import ReturnPolicy_VDay from './pages/legal/ReturnPolicy_VDay.vue'; //VDay 退換貨規則
import ReturnPolicy_MiruWonderland from './pages/legal/ReturnPolicy_MiruWonderland.vue'; //米嚕節目退換貨規則
//*** Download ***//
import DownloadPage from './pages/DownloadPage.vue'; // 程式下載

//--------------------- Login ---------------------//
import MemberLogin from './pages/LoginPage.vue'; // Login_RouterView
import Login from '@/pages/login/Login.vue'; // 登入
import Register from '@/pages/login/Register.vue'; // 註冊
import ForgotPassword from '@/pages/login/ForgotPassword.vue'; // 忘記密碼
import RegisterMemberInfo from '@/pages/login/RegisterMemberInfo.vue'; // 必填會員資料

//--------------------- MemberCenter ---------------------//
import Member from './pages/MemberPage.vue'; // 會員中心_RouterView
import TicketSection from '@/pages/memberCenter/TicketSection.vue'; // 票券專區
//*** SerialNumber ***//
import SerialNumber from '@/pages/memberCenter/SerialNumber.vue'; // 序號兌換主頁
import SerialNumberDefault from '@/pages/memberCenter/SerialNumberDefault.vue'; // 序號兌換
import AccountBinding from '@/pages/accountSetting/AccountBinding.vue'; //VR 序號票券綁定
import RegistrationBinding from '@/pages/accountSetting/RegistrationBinding.vue'; //VR 序號票券創建
//*** AccountSetting ***//
import MemberInfo from '@/pages/memberCenter/MemberInfo.vue'; //會員資料
import ResetPassword from '@/pages/memberCenter/ResetPassword.vue'; //重設密碼
import UserBackpack from '@/pages/memberCenter/UserBackpack.vue'; // 我的道具
import MyOrders from '@/pages/memberCenter/MyOrders.vue'; // 我的訂單
import OrderDetails from '@/pages/memberCenter/MyOrderDetails.vue'; // 我的訂單 > 詳細訂單

//--------------------- Event ---------------------//
import Event from './pages/Event.vue';
// import Illusionary from './pages/event/Illusionary.vue'; //鏡花水月
// import VDay from './pages/event/VDay.vue' //VDay
import MiruWonderland from './pages/event/MiruWonderland.vue'; //Annin Miru Wonderland

//--------------------- Test ---------------------//
import StreamingPage from '@/pages/programVideo/StreamingPage.vue';

const routes = [
  {
    path: '/',
    redirect: `/${store.state.currentLanguage}`,
  },
  {
    path: '/:lang',
    component: RouterViewPage,
    redirect: '',
    children: [
      {
        path: 'streaming/:roomId',
        name: 'streamingVideo',
        component: StreamingPage,
        meta: {
          title: 'program | BEATDAY',
        },
      },
      {
        path: '',
        name: 'home',
        component: Index,
        meta: {
          title: 'BEATDAY',
        },
      },
      {
        path: 'products',
        name: 'products',
        component: Products, // 產品
        meta: {
          zh_tw: { title: '產品 | BEATDAY' },
          en: { title: 'Products | BEATDAY' },
        },
      },
      {
        path: 'product-info/:id',
        name: 'product-info',
        component: ProductInfo, // 產品詳情
        meta: {
          zh_tw: { title: '產品詳情 | BEATDAY' },
          en: { title: 'Product Details | BEATDAY' },
        },
      },
      {
        path: 'cart',
        name: 'shopping-cart',
        component: ShoppingCart, // 產品詳情
        meta: {
          zh_tw: { title: '商品購物車 | BEATDAY' },
          en: { title: 'Cart | BEATDAY' },
        },
      },
      {
        path: 'gift-shop',
        name: 'gift-shop',
        component: giftShop, // 禮包商店
        redirect: { name: 'gift-item' },
        children: [
          {
            path: 'giftPack',
            name: 'gift-pack',
            component: giftPack,
            meta: { title: '禮包折扣 | BEATDAY' },
          },
          {
            path: 'giftItem',
            name: 'gift-item',
            component: giftItem,
            meta: { title: '商品 | BEATDAY' },
          },
        ],
      },
      {
        path: 'order-complete',
        name: 'order-complete',
        component: OrderComplete,
        meta: {
          zh_tw: { title: '完成訂單 | BEATDAY' },
          en: { title: 'OrderComplete | BEATDAY' },
        },
      },
      {
        path: 'order-complete-streaming',
        name: 'order-complete-streaming',
        component: OrderCompleteStreaming,
        meta: {
          zh_tw: { title: '完成訂單 | BEATDAY' },
          en: { title: 'OrderCompleteStreaming | BEATDAY' },
        },
      },
      {
        path: 'faq',
        name: 'faq',
        component: FAQ,
        redirect: { name: 'account-issues' },
        children: [
          {
            path: 'account-issues',
            name: 'account-issues',
            component: AccountIssues,
            meta: { title: '帳號問題 | BEATDAY' },
          },

          {
            path: 'ticket-issues',
            name: 'ticket-issues',
            component: TicketIssues,
            meta: { title: '票務問題 | BEATDAY' },
          },
          {
            path: 'redemption-guide',
            name: 'redemption-guide',
            component: RedemptionGuide,
            meta: { title: '兌票教學 | BEATDAY' },
          },
          {
            path: 'beatday-usage',
            name: 'beatday-usage',
            component: BeatdayUsage,
            meta: { title: 'BEATDAY 使用 | BEATDAY' },
          },
        ],
      },
      {
        path: 'history-review',
        name: 'history-review',
        component: HistoryReview,
        meta: { title: '精選回顧 | BEATDAY' },
      },
      {
        path: 'history-review-detail',
        name: 'history-review-detail',
        component: HistoryReviewDetail,
        meta: {
          zh_tw: { title: '產品詳情 | BEATDAY' },
          en: { title: 'HistoryReviewDetail | BEATDAY' },
        },
      },
      {
        path: 'aboutUs',
        name: 'about-us',
        component: AboutUs,
        redirect: { name: 'about-beatday' },
        children: [
          {
            path: 'about-beatday',
            name: 'about-beatday',
            component: AboutBeatday,
            meta: { title: '關於BEATDAY | BEATDAY' },
          },
          {
            path: 'business-cooperation',
            name: 'business-cooperation',
            component: BusinessCooperation,
            meta: { title: '商務合作 | BEATDAY' },
          },
          {
            path: 'contact-us',
            name: 'contact-us',
            component: ContactUs,
            meta: { title: '聯繫我們 | BEATDAY' },
          },
        ],
      },
      {
        path: 'downloads',
        name: 'downloads',
        component: DownloadPage,
        meta: { title: '程式下載 | BEATDAY' },
      },
      {
        path: 'legal',
        name: 'legal',
        component: Legal,
        children: [
          {
            path: 'privacy',
            name: 'privacy',
            component: Privacy,
            meta: { title: '隱私權政策 | BEATDAY' },
          },
          {
            path: 'user-policy',
            name: 'user-policy',
            component: UserPolicy,
            meta: { title: '使用條款 | BEATDAY' },
          },
          {
            path: 'SAR-policy',
            name: 'sales-and-return-policy',
            component: SalesAndReturnPolicy,
            meta: { title: '銷售及退換條款 | BEATDAY' },
          },
          {
            path: 'legal-versions',
            name: 'legal-versions',
            component: LegalVersions,
            meta: { title: '封存版本清單 | BEATDAY' },
          },
        ],
      },
      {
        path: 'return-policy-MizukiLin',
        name: 'return-policy-MizukiLin',
        component: ReturnPolicyMizukiLin,
        meta: { title: '林襄沉浸式寫真 | BEATDAY' },
      },
      {
        path: 'return-policy-VDay',
        name: 'return-policy-VDay',
        component: ReturnPolicy_VDay,
        meta: { title: '2024漫博 VDay誕生日 | BEATDAY' },
      },
      {
        path: 'return-policy-MiruWonderland',
        name: 'return-policy-MiruWonderland',
        component: ReturnPolicy_MiruWonderland,
        meta: { title: '杏仁ミル 週末 Party Night | BEATDAY' },
      },
      {
        path: 'member-login',
        name: 'member-login',
        component: MemberLogin,
        children: [
          {
            path: 'login',
            name: 'login',
            component: Login,
            meta: { title: '會員登入 | BEATDAY' },
          },
          {
            path: 'register',
            name: 'register',
            component: Register,
            meta: { title: '會員註冊 | BEATDAY' },
          },
          {
            path: 'forgot-password',
            name: 'forgot-password',
            component: ForgotPassword,
            meta: { title: '忘記密碼 | BEATDAY' },
          },
        ],
      },
      {
        path: 'register-memberInfo',
        name: 'register-memberInfo',
        component: RegisterMemberInfo,
        meta: { title: '會員資料註冊 | BEATDAY' },
      },
      {
        path: 'member',
        name: 'member',
        component: Member,
        redirect: { name: 'member-info' },
        children: [
          {
            path: 'ticket-section',
            name: 'ticket-section',
            component: TicketSection,
            meta: { title: '票券專區 | BEATDAY' },
          },
          {
            path: 'user-backpacks',
            name: 'user-backpacks',
            component: UserBackpack,
            meta: { title: '會員背包 | BEATDAY' },
          },
          {
            path: 'serial-number',
            name: 'serial-number',
            component: SerialNumber,
            redirect: { name: 'serial-number-default' },
            children: [
              {
                path: 'serial-number-default', // 空路径表示默认子路由
                name: 'serial-number-default',
                component: SerialNumberDefault,
                meta: { title: '序號兌換 | BEATDAY' },
              },
              {
                path: 'account-binding',
                name: 'account-binding',
                component: AccountBinding,
                meta: { title: '綁定 | BEATDAY' },
              },
              {
                path: 'registration-binding',
                name: 'registration-binding',
                component: RegistrationBinding,
                meta: { title: '創建 | BEATDAY' },
              },
            ],
          },
          {
            path: 'member-info',
            name: 'member-info',
            component: MemberInfo,
            meta: { title: '會員資料 | BEATDAY' },
          },
          {
            path: 'reset-password',
            name: 'reset-password',
            component: ResetPassword,
            meta: { title: '重設密碼 | BEATDAY' },
          },
          {
            path: 'my-orders',
            name: 'my-orders',
            component: MyOrders,
            meta: { title: '我的訂單 | BEATDAY' },
          },
          {
            path: 'order-details/:id',
            name: 'order-details',
            component: OrderDetails,
            meta: { title: '我的訂單 | BEATDAY' },
          },
        ],
      },
      {
        path: 'event',
        name: 'event',
        component: Event,
        children: [
          {
            path: 'AMW%3C3',
            name: 'AMW%3C3',
            component: MiruWonderland,
            meta: {
              zh_tw: {
                title: '杏仁ミル 週末 Party Night！ | BEATDAY',
              },
              en: {
                title: '杏仁ミル 週末 Party Night！| BEATDAY',
              },
              ja: {
                title: '杏仁ミル 週末 Party Night！ | BEATDAY',
              },
            },
          },
          // {
          //   path: 'illusionary',
          //   name: 'illusionary',
          //   component: Illusionary,
          //   meta: { title: '鏡花水月 | BEATDAY' },
          // },
        ],
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: Maintenance,
        meta: { title: 'Maintenance | BEATDAY' },
      },
    ],
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/zh_tw',
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { top: 0 };
    }
  },
});

import { webStatus } from '@/api/lambdaApiService.js';

router.beforeEach(async (to, from, next) => {
  const currentLanguage = store.state.currentLanguage; // 獲取當前語言

  // for facebook oauth will redirect to /_=_
  if (to.fullPath === '/_=_' || to.fullPath === '#/_=_') {
    return next(`/${currentLanguage}`); // 直接導向 /zh_tw
  }

  const newLang = to.params.lang;
  const oldLang = from.params.lang;

  const gtm = useGtm(); // 取得 GTM 實例
  if (gtm) {
    gtm.trackEvent({
      event: 'manual_page_view',
      custom_page_path: to.fullPath,
      language: currentLanguage,
    });
  }

  if (to.meta && to.meta[currentLanguage] && to.meta[currentLanguage].title) {
    document.title = to.meta[currentLanguage].title;
  } else {
    document.title = 'BEATDAY';
  }
  try {
    if (store.state.isMaintenance === null) {
      const langSetting = store.state.currentLanguage === 'zh_tw' ? 'zh-tw' : store.state.currentLanguage;
      const response = await webStatus(langSetting);

      if (response.data?.status === 'active') {
        store.commit('setMaintenanceMode', false);
      } else if (response.data?.status === 'maintenance') {
        store.commit('setMaintenanceMode', true);
      } else {
        console.error('Unexpected status from webStatus API:', response.data?.status);
        store.commit('setMaintenanceMode', false);
      }
    }
    const isMaintenance = store.state.isMaintenance;

    if (isMaintenance && to.name !== 'maintenance') {
      next({ name: 'maintenance', params: { lang: newLang } }); //維護開啟 > 導向維護頁面
    } else if (!isMaintenance && to.name === 'maintenance') {
      next({ name: 'home', params: { lang: newLang } }); //維護關閉＆要進入維護頁面 > 導向首頁
    } else {
      if (newLang !== oldLang) {
        const lang = await loadLanguageAsync(newLang);
        await store.dispatch('setLanguage', lang);

        // 如果語言有變更，則重新導向
        if (lang !== newLang) {
          return next(`/${lang}`);
        }
      } else {
        await loadLanguageAsync(newLang);
      }

      next();
    }
  } catch (error) {
    console.error('Failed to fetch maintenance status:', error);
    if (to.name !== 'home') {
      next({ name: 'home', params: { lang: newLang } });
    } else {
      next();
    }
  }
});

router.afterEach((to, from) => {
  const newLang = to.params.lang;
  const oldLang = from.params.lang;

  if (oldLang && newLang !== oldLang) {
    window.location.reload();
  }
});

export default router;
